module.exports = require("got");


//////////////////
// WEBPACK FOOTER
// external "got"
// module id = got
// module chunks = 3